import { render } from "./Text.vue?vue&type=template&id=1006f724&scoped=true&ts=true"
import script from "./Text.vue?vue&type=script&lang=ts"
export * from "./Text.vue?vue&type=script&lang=ts"

import "./Text.vue?vue&type=style&index=0&id=1006f724&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1006f724"]])

export default __exports__